export const SCROLL_TO_CLASS = 'fauluLoanCalculator/scrolling/transition/scrollToClass';
export const SCROLL_TO_ID = 'fauluLoanCalculator/scrolling/transition/scrollToId';
export const CLEAR_SCROLL = 'fauluLoanCalculator/scrolling/transition/resetScroll';

export const transitionScrolling = {
    scrollToClass: (value) => ({type: SCROLL_TO_CLASS, value}),
    scrollToId: (value) => ({type: SCROLL_TO_ID, value}),
}

export const resetScroll = () => ({ type: CLEAR_SCROLL });